import type { FunctionMeta } from '../function.model';

// =============================================================================
// PARAMS - Mathematical definition
// =============================================================================

/** Linear function parameters in slope-intercept form: m*x + b */
export interface LinearParams {
  /** Slope */
  m: number;
  /** Y-intercept */
  b: number;
}

// =============================================================================
// META - Function configuration (type-checked)
// =============================================================================

/**
 * Configuration metadata for linear functions.
 * Handle is placed at x=0 (the y-intercept point).
 */
export const LINEAR_META: FunctionMeta<LinearParams> = {
  availableFeatures: [
    'handle',
    'roots',
    'tangent',
    'secant',
    'derivative',
    'intersection',
    'yIntercept',
    'trajectory',
    'monotonicity',
    'functionArea',
    'intersectionArea',
    'domain',
    'range',
  ],
  handleConfigs: {
    translate: {
      xParam: 'b',
      yParam: 'b',
      // Handle at y-intercept: (0, b)
      toPosition: (p) => [0, p['b']],
      // When dragged: update b based on y position (x is fixed at 0)
      fromPosition: (_x, y) => ({ b: y }),
    },
    'translate-y': {
      xParam: 'b',
      yParam: 'b',
      // Handle at y-intercept: (0, b)
      toPosition: (p) => [0, p['b']],
      // Only vertical movement affects b
      fromPosition: (_x, y) => ({ b: y }),
    },
  },
  defaultParams: {
    m: 1,
    b: 0,
  },
  defaultRanges: {
    m: [-10, 10],
    b: [-10, 10],
  },
};
